var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEnterprise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52,
    height: 43,
    viewBox: "0 0 52 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_80",
    "data-name": "Group 80",
    transform: "translate(-0.092 -0.349)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    d: "M47.089,84.9H5.852A5.374,5.374,0,0,1,.426,79.47V53.426A5.374,5.374,0,0,1,5.852,48H47.089a5.374,5.374,0,0,1,5.426,5.426V79.47A5.374,5.374,0,0,1,47.089,84.9M5.852,50.17A3.338,3.338,0,0,0,2.6,53.426V79.47a3.338,3.338,0,0,0,3.256,3.256H47.089a3.338,3.338,0,0,0,3.256-3.256V53.426a3.338,3.338,0,0,0-3.256-3.256Z",
    transform: "translate(-0.611 -41.487)",
    fill: "#2b3385",
    stroke: "#2b3385",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M144.7,8.681A1.025,1.025,0,0,1,143.619,7.6V3.256a1.025,1.025,0,0,0-1.085-1.085H131.682A1.025,1.025,0,0,0,130.6,3.256V7.6a1.085,1.085,0,0,1-2.17,0V3.256A3.338,3.338,0,0,1,131.682,0h10.852a3.338,3.338,0,0,1,3.256,3.256V7.6A1.025,1.025,0,0,1,144.7,8.681",
    transform: "translate(-111.248 0.002)",
    fill: "#2b3385",
    stroke: "#2b3385",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    d: "M26.1,122.333h-.434L.709,113.651a1.324,1.324,0,0,1-.651-1.519,1.324,1.324,0,0,1,1.519-.651L26.1,120.162l24.525-8.681a1.029,1.029,0,0,1,.651,1.953l-24.959,8.681c0,.217,0,.217-.217.217",
    transform: "translate(-0.243 -96.286)",
    fill: "#2b3385",
    stroke: "#2b3385",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnterprise);
export default __webpack_public_path__ + "static/media/icon_enterprise.825859cd4ddc39aa8685f5d2b11996d8.svg";
export { ForwardRef as ReactComponent };